import React from 'react';
import BaseFactory from './BaseFactory';
import {
  getBlogAnchorTag,
  getFaqsAnchorTag,
  hasLocationHours,
  NoTopMarginParagraph,
  NoBottomMarginParagraph,
  hasCustomDescription,
} from './util';
import { isEmptyArray } from '../../../core/util/array';
import CustomDescriptionSection from './CustomDescriptionSection';
import { SOLV_SECTION_TITLE } from './constants';

class NonPartnerSpecialtyUrgentCare extends BaseFactory {
  getDescription() {
    return (
      `${this.clinicName} is a ${this.clinicalCategory}` +
      `located at ${this.address}, ${this.city}, ` +
      `${this.state}, ${this.zip}. While they share the name "urgent care," their services ` +
      'are specialized and focused. For more ' +
      `information, call ${this.clinicName}${this.phoneString}.`
    );
  }

  getKeywords() {
    return (
      `${this.clinicName}, ${this.clinicName}, ${this.city}, ${this.clinicName} ${this.zip}, ` +
      `${this.clinicalCategory} ${this.city}, ${this.clinicalCategory} ${this.zip}, ` +
      `walk-in clinic ${this.city}, walk-in clinic ${this.zip}, ${this.city} ${this.state} ` +
      `walk-in clinic, ${this.zip} walk-in clinic`
    );
  }

  getBody() {
    return (
      <div>
        <CustomDescriptionSection location={this.location} />
        <NoTopMarginParagraph>
          {hasCustomDescription(this.location) && (
            <span>
              {SOLV_SECTION_TITLE}
              <br />
            </span>
          )}
          {this.clinicName} offers a newer form of convenient care called {this.clinicalCategory}.
          While using the term "urgent care," they are more specialized in their offerings and may
          not offer the full breadth of urgent care services in their {this.city}, {this.state}{' '}
          clinic at {this.fullAddress}.{' '}
          {hasLocationHours(this.location) && (
            <span>
              They are open {this.numDaysOpenString} a week including {this.nextOpenDayName} from{' '}
              {this.nextOpenDayHoursStr} and appear to accept walk-in patients.{' '}
            </span>
          )}
          It is recommended that you call before your visit to ensure they offer the service you
          need and accept the insurance or payment method you have.
        </NoTopMarginParagraph>
        {isEmptyArray(this.glowingWords) && this.rating && (
          <p>
            Patients have given an average rating of {this.rating} stars out of 5 for their
            experience at <b>{this.clinicName}</b>.
          </p>
        )}
        {!isEmptyArray(this.glowingWords) && !this.rating && (
          <p>
            Patients have used words like {this.glowingWordsString} when reviewing{' '}
            <b>{this.clinicName}</b>.
          </p>
        )}
        {!isEmptyArray(this.glowingWords) && this.rating && (
          <p>
            With patients using words like {this.glowingWordsString} when reviewing{' '}
            <b>{this.clinicName}</b>, they have amassed an average rating of {this.rating} stars out
            of 5.
          </p>
        )}
        <NoBottomMarginParagraph>
          If you are looking to learn more about {this.clinicalCategory} including statistics,
          trends, {getFaqsAnchorTag()} and other useful information, check out our{' '}
          {getBlogAnchorTag()} to empower your knowledge as a healthcare consumer.{' '}
          {this.cityGuideContent}
        </NoBottomMarginParagraph>
      </div>
    );
  }
}

export default NonPartnerSpecialtyUrgentCare;
